import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  static values = {
    texts: Array,
    interval: { type: Number, default: 3000 }
  }

  connect() {
    console.log("✅ placeholder controller connected:", this.identifier);
    this.index = 0
    this.updatePlaceholder()
    this.timer = setInterval(() => this.updatePlaceholder(), this.intervalValue)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  updatePlaceholder() {
    const text = this.textsValue[this.index]
    this.inputTarget.placeholder = text
    this.index = (this.index + 1) % this.textsValue.length
  }
}
